export default __webpack_public_path__ + "static/grey-rip-bottom-8e74989994c13e1385c995ebfe214876.png";